import { render } from "./TronEduItem.vue?vue&type=template&id=32def75d"
import script from "./TronEduItem.vue?vue&type=script&lang=js"
export * from "./TronEduItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/olt/CloudRaiseWebSite/vue/client/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__